import Divider from "../../../components/overrides/Divider";

export const showDivider = (condition) => condition && <Divider />;